module.exports = __webpack_public_path__ + "static/media/fuck-you.c34489a4.svg";